'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _dec2, _class, _class2, _temp;

var _queryString = require('query-string');

var _queryString2 = _interopRequireDefault(_queryString);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _nodePolyglot = require('node-polyglot');

var _nodePolyglot2 = _interopRequireDefault(_nodePolyglot);

var _reactAddonsUpdate = require('react-addons-update');

var _reactAddonsUpdate2 = _interopRequireDefault(_reactAddonsUpdate);

var _reactDocumentMeta = require('react-document-meta');

var _reactDocumentMeta2 = _interopRequireDefault(_reactDocumentMeta);

var _reactRedux = require('react-redux');

var _venues = require('redux/modules/venues');

var venueActions = _interopRequireWildcard(_venues);

var _reduxRouter = require('redux-router');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _components = require('components');

var _reactBootstrap = require('react-bootstrap');

var _OrderPick = require('components/Form/OrderPick');

var _OrderPick2 = _interopRequireDefault(_OrderPick);

var _utils = require('utils');

var _decorate = require('helpers/decorate');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Venue = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    destroyed: state.venues.destroyed,
    entity: 'venues',
    error: state.venues.error,
    queryParams: state.venues.queryParams,
    user: state.auth.user,
    venues: state.venues.venues
  };
}, (0, _extends3.default)({}, venueActions, { push: _reduxRouter.push, replace: _reduxRouter.replace })), _dec2 = (0, _decorate.container)(), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Venue, _Component);

  function Venue(props, context, updater) {
    (0, _classCallCheck3.default)(this, Venue);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Venue.__proto__ || (0, _getPrototypeOf2.default)(Venue)).call(this, props, context, updater));

    _this.state = {
      isModalOpen: false,
      selectedEditItem: {}
    };


    _this.state.snackbar = (0, _utils.snackbarInitialState)();
    return _this;
  }

  (0, _createClass3.default)(Venue, [{
    key: 'onPagerSelect',
    value: function onPagerSelect(eventKey) {
      var queryParams = this.props.queryParams;
      var push = this.props.push; // eslint-disable-line no-shadow

      queryParams = (0, _extends3.default)({}, queryParams, eventKey);

      push({ pathname: '/venues', query: queryParams });
    }
  }, {
    key: 'onFilterVenues',
    value: function onFilterVenues(venue) {
      var _this2 = this;

      var newFilter = {
        q: venue.target.value.trim(),
        page: 1
      };

      if (this.filterTextListener) {
        clearTimeout(this.filterTextListener);
      }

      this.filterTextListener = setTimeout(function () {
        _this2.onPagerSelect(newFilter);
      }, 800);
    }
  }, {
    key: 'canOpenModal',
    value: function canOpenModal() {
      return ['super_admin', 'admin', 'editor'].indexOf(this.props.user.role) > -1;
    }
  }, {
    key: 'reloadVenues',
    value: function reloadVenues() {
      var _props = this.props,
          queryParams = _props.queryParams,
          load = _props.load;

      load(queryParams);
    }
  }, {
    key: 'handleDestroy',
    value: function handleDestroy(venueId, evt) {
      var _this3 = this;

      evt.preventDefault();

      var _props2 = this.props,
          destroy = _props2.destroy,
          locale = _props2.user.lang; // 194

      var venuePhrases = require('./../../locales/' + locale + '/venues.js');
      var appPhrases = require('./../../locales/' + locale + '/app.js');
      var polyglot = new _nodePolyglot2.default({
        locale: locale,
        phrases: (0, _extends3.default)({}, venuePhrases, appPhrases)
      });

      destroy(venueId).then(function (res) {
        if (res.type === 'caligram/venues/DESTROY_SUCCESS') {
          var snackbar = _this3.state.snackbar;


          snackbar = (0, _reactAddonsUpdate2.default)(snackbar, {
            $merge: {
              id: venueId,
              isActive: true,
              message: polyglot.t('snackbar.venueDestroyed', { title: res.result.name ? (0, _utils.trunc)(res.result.name, 20, true) : '' }),
              action: polyglot.t('snackbar.undo'),
              currentAction: res.type
            }
          });

          _this3.setState({ snackbar: snackbar });
        }
      });
    }
  }, {
    key: 'hideSnackbar',
    value: function hideSnackbar() {
      var snackbar = this.state.snackbar;


      snackbar = (0, _reactAddonsUpdate2.default)(snackbar, {
        $merge: {
          id: 0,
          isActive: false
        }
      });

      this.setState({ snackbar: snackbar });
    }
  }, {
    key: 'handleDismissSnackbar',
    value: function handleDismissSnackbar() {
      this.hideSnackbar();
    }
  }, {
    key: 'handleClickSnackbar',
    value: function handleClickSnackbar() {
      var _this4 = this;

      var snackbar = this.state.snackbar;


      switch (snackbar.currentAction) {
        case 'caligram/venues/DESTROY_SUCCESS':
          var _props3 = this.props,
              restore = _props3.restore,
              destroyed = _props3.destroyed;
          // FIXME: doesn't reappear in the list after restore

          restore(destroyed.id).then(function (res) {
            if (res.type === 'caligram/venues/RESTORE_SUCCESS') {
              _this4.hideSnackbar();
            }
          });
          break;
        default:
          break;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this,
          _context2;

      var _props4 = this.props,
          venues = _props4.venues,
          queryParams = _props4.queryParams;
      var locale = this.props.user.lang;


      var venuePhrases = require('./../../locales/' + locale + '/venues.js');
      var appPhrases = require('./../../locales/' + locale + '/app.js');

      var polyglot = new _nodePolyglot2.default({
        locale: locale,
        phrases: (0, _extends3.default)({}, venuePhrases, appPhrases)
      });
      var snackbar = this.state.snackbar;


      var meta = {
        pagination: {
          current_page: 0,
          total: 0,
          total_pages: 0
        }
      };

      if (venues && venues.meta) {
        meta = venues.meta;
      }

      var venueData = [];
      if (venues && venues.data) {
        venueData = venues.data;
      }

      var showPager = (0, _classnames2.default)({
        hide: meta.pagination.total_pages <= 1
      });

      var pagerPrevDisabled = meta.pagination.current_page <= 1;
      var pagerNextDisabled = meta.pagination.current_page >= meta.pagination.total_pages;

      var pager = _react2.default.createElement(
        _reactBootstrap.Pager,
        { onSelect: this.onPagerSelect.bind(this), className: showPager },
        _react2.default.createElement(
          _reactBootstrap.Pager.Item,
          { className: 'icon-cg-chevron-left', disabled: pagerPrevDisabled, eventKey: { page: meta.pagination.current_page - 1 }, href: '#?previous' },
          polyglot.t('venues.previous')
        ),
        '\xA0',
        _react2.default.createElement(
          _reactBootstrap.Pager.Item,
          { className: 'icon-cg-chevron-right', disabled: pagerNextDisabled, eventKey: { page: meta.pagination.current_page + 1 }, href: '#?next' },
          polyglot.t('venues.next')
        )
      );

      var filters = _react2.default.createElement(
        'div',
        { className: 'filters clearfix' },
        _react2.default.createElement(
          'div',
          { className: 'form-inline' },
          _react2.default.createElement(
            'div',
            { className: 'form-group pull-right' },
            _react2.default.createElement('input', { type: 'search', className: 'form-control', placeholder: '\xA0', defaultValue: queryParams.q, onChange: this.onFilterVenues.bind(this) })
          )
        )
      );

      var venuesList = venueData.length ? venueData.map(function (venue) {
        var _context;

        return _react2.default.createElement(_components.VenueItem, {
          key: String(venue.id),
          venue: venue,
          openModal: (_context = _this5.openModal).bind.call(_context, _this5, venue),
          destroy: _this5.handleDestroy.bind(_this5),
          polyglot: polyglot
        });
      }) : polyglot.t('venues.empty');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_reactDocumentMeta2.default, { title: polyglot.t('navigation.venues') + ' - Caligram' }),
        _react2.default.createElement(
          'div',
          { className: 'header' },
          _react2.default.createElement(
            'button',
            {
              type: 'button',
              className: 'btn btn-lg btn-primary pull-right',
              onClick: (_context2 = this.openModal).bind.call(_context2, this, {})
            },
            polyglot.t('venues.new')
          ),
          _react2.default.createElement(
            'h1',
            null,
            polyglot.t('venues.title')
          )
        ),
        filters,
        _react2.default.createElement(
          'div',
          { className: 'results' },
          _react2.default.createElement(
            _OrderPick2.default,
            { type: 'venues', queryParams: queryParams, total: meta.pagination.total, onPagerSelect: this.onPagerSelect.bind(this), polyglot: polyglot },
            _react2.default.createElement(
              _reactBootstrap.MenuItem,
              { eventKey: 'name' },
              polyglot.t('venues.sortOrder.name')
            ),
            _react2.default.createElement(
              _reactBootstrap.MenuItem,
              { eventKey: 'creation' },
              polyglot.t('venues.sortOrder.created_at')
            ),
            _react2.default.createElement(
              _reactBootstrap.MenuItem,
              { eventKey: 'modification' },
              polyglot.t('venues.sortOrder.updated_at')
            )
          ),
          venuesList,
          pager
        ),
        _react2.default.createElement(_components.VenueModal, {
          isModalOpen: this.state.isModalOpen,
          closeModal: this.closeModal.bind(this),
          venueId: this.state.selectedEditItem.id,
          polyglot: polyglot
        }),
        _react2.default.createElement(_components.Snackbar, (0, _extends3.default)({
          ref: 'snackbar'
        }, snackbar, {
          style: (0, _utils.snackbarStyle)(),
          onDismiss: this.handleDismissSnackbar.bind(this),
          onClick: this.handleClickSnackbar.bind(this),
          polyglot: polyglot
        }))
      );
    }
  }], [{
    key: 'fetchData',
    value: function fetchData(getState, dispatch, location) {
      var state = getState();
      var queryParams = state.venues.queryParams;

      var parsedParams = _queryString2.default.parse(location.search);

      var mergedParams = (0, _extends3.default)({}, queryParams, parsedParams);

      var paramsChanged = _queryString2.default.stringify(queryParams) !== _queryString2.default.stringify(mergedParams);
      if (paramsChanged || !(state.venues.loaded || state.venues.loading)) {
        dispatch((0, _venues.changeFilter)(mergedParams));

        return dispatch((0, _venues.load)((0, _extends3.default)({}, mergedParams, { editable: true })));
      }
    }
  }]);
  return Venue;
}(_react.Component), _class2.propTypes = {
  destroy: _propTypes2.default.func.isRequired,
  destroyed: _propTypes2.default.object,
  entity: _propTypes2.default.string.isRequired,
  load: _propTypes2.default.func,
  push: _propTypes2.default.func.isRequired,
  queryParams: _propTypes2.default.object,
  restore: _propTypes2.default.func.isRequired,
  user: _propTypes2.default.object,
  venues: _propTypes2.default.any
}, _temp)) || _class) || _class);
exports.default = Venue;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Venue/Venue.js
// module id = 2274
// module chunks = 0